import {
  CreditCardToolbox20Regular,
  DismissRegular,
  SignOut20Regular,
} from "@fluentui/react-icons";
import useMixpanel from "hooks/useMixpanel";
import React from "react";
import { ReactComponent as BusinessLogo } from "assets/BusinessLogo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "constants/routes";
import { RootState } from "store";
import { useAppSelector } from "hooks/useRedux";
import { useLocalStorage } from "hooks/useLocalStorage";
interface IHeaderPopoverContentProps {
  authContext: any;
  setOpen: Function;
  onClose: () => void;
}

const HeaderPopoverContent: React.FC<IHeaderPopoverContentProps> = ({
  authContext,
  setOpen,
  onClose,
}) => {
  const { trackEvent } = useMixpanel();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const defaultAccount = useAppSelector(
    (state: RootState) => state.defaultAccount.defaultAccount
  );
  const [selectedBusiness, setSelectedBusiness] = useLocalStorage(
    "selectedBusiness",
    null
  );
  const iconClass = "inline-block h-8 w-8 rounded-full m-auto mr-2 text-black";
  const navigateToBusiness = () => {
    navigate(`${routes.chooseBusiness}/1`, {
      state: { restrictBusinessRefresh: true },
    });
    onClose();
  };
  const logout = () => authContext?.logout();
  const businessState = useAppSelector((state: RootState) => state.businesses);
  const options = [
    {
      show: !pathname.includes(routes?.chooseBusiness),
      icon: <BusinessLogo className={iconClass} />,
      text: "Switch Business",
      action: () => {
        trackEvent("choose_business_dropdown_Clicking");
        navigateToBusiness();
      },
    },
    {
      show: !!defaultAccount && pathname !== routes?.paymentManagement,
      icon: <CreditCardToolbox20Regular className={iconClass} />,
      text: "Payment Management",
      action: () => {
        trackEvent("payment_management_click");
        navigate(routes.paymentManagement);
        onClose();
      },
    },
    {
      show: true,
      icon: <SignOut20Regular className={`${iconClass} !text-failed`} />,
      text: <span className="text-failed">Signout</span>,
      action: () => {
        trackEvent("signout_Clicking");
        logout();
      },
    },
  ];

  const filteredOptions = options.filter((option) => !!option.show);

  return (
    <div className="flex flex-col gap-4 ">
      <div
        className="flex gap-4 items-end md:items-center "
        onClick={() => setOpen(true)}
      >
        <div className="text-base font-medium block self-center flex-1">
          {authContext?.user?.name}
        </div>
        <DismissRegular
          className="m-auto block md:hidden cursor-pointer "
          fontSize={24}
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        />
      </div>
      {filteredOptions?.map((option) => {
        return (
          <>
            <div
              key={option?.text.toString()}
              className="cursor-pointer "
              onClick={() => option?.action()}
            >
              {option?.icon}
              {option?.text}
            </div>
            <div className="border-b-2 border-color-gray-100" />
          </>
        );
      })}
    </div>
  );
};

export default HeaderPopoverContent;
